var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPr(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    width: "800px",
    height: "800px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M11.77,5.67V7h1.4V5.67A2.37,2.37,0,0,0,10.8,3.3H10V4.7h.8A1,1,0,0,1,11.77,5.67ZM4,2a2,2,0,0,0-.7,3.87v5.26a2,2,0,1,0,1.4,0V5.87A2,2,0,0,0,5.87,4.7H8V3.3H5.87A2,2,0,0,0,4,2ZM4,13.6a.6.6,0,1,1,.6-.6A.6.6,0,0,1,4,13.6Zm0-9A.6.6,0,1,1,4.6,4,.6.6,0,0,1,4,4.6Zm9.17,6.53V9h-1.4v2.13a2,2,0,1,0,1.4,0Zm-.7,2.47a.6.6,0,1,1,.6-.6A.6.6,0,0,1,12.47,13.6Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPr);
export default __webpack_public_path__ + "static/media/pr.a4f6e4dccd47560e7a624c68a4742412.svg";
export { ForwardRef as ReactComponent };